export const SILO_TYPE = {
    RAW_MILK_DROPOFF: 'raw_milk_dropoff',
    PROCESSED_FLUID_PICKUP: 'processed_fluid_pickup',
    PROCESSED_FLUID_DROPOFF: 'processed_fluid_dropoff',
};

export const SILO_TYPES = [
    { value: 'raw_milk_dropoff', label: 'Dropoff (Raw Milk)' },
    { value: 'processed_fluid_pickup', label: 'Pickup (Processed Fluid)' },
    { value: 'processed_fluid_dropoff', label: 'Dropoff (Processed Fluid)' },
];

export const SILO_TYPE_LABELS = SILO_TYPES.reduce((acc, { value, label }) => ({ ...acc, [value]: label }), {});

export const formatSiloTypes = (types) => {
    if (!Array.isArray(types) || types.length === 0) return '-';
    return types.map((type) => SILO_TYPE_LABELS[type] ?? type).join(', ');
};
